module.exports = __webpack_public_path__ + "img/charging-station-solid.09f86750.svg";